import TimeAgo from "javascript-time-ago";
import gb from 'javascript-time-ago/locale/en-GB.json'
TimeAgo.addLocale(gb)
const timeAgo = new TimeAgo('en-GB')

export const timeago = value => {
    return timeAgo.format(new Date(value));
}
